import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as packageJson from '../../../package.json';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.css']
})
export class MainFooterComponent implements OnInit {

  constructor() { }
  // public ver :string = environment.appVersion ;
  public ver :string = packageJson.version ;
  ngOnInit() {
  }

}
